import { render, staticRenderFns } from "./amountRateStatistice.vue?vue&type=template&id=16fc46fa&scoped=true"
import script from "./amountRateStatistice.vue?vue&type=script&lang=js"
export * from "./amountRateStatistice.vue?vue&type=script&lang=js"
import style0 from "./amountRateStatistice.vue?vue&type=style&index=0&id=16fc46fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fc46fa",
  null
  
)

export default component.exports